/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

import type { ReactNode } from 'react';
import type { CommonLoaderComponentProps } from './GlobalLoaderProvider';

export type GlobalLoaderStateParams<
  LoaderComponentProps extends Record<string, unknown> = Record<string, unknown>,
> = {
  /**
   * openLoader 시 표시할 LoaderComponent를 설정합니다.
   * ex. Component: (props) => <CustomLoader {...props} />
   */
  Component?: (props: CommonLoaderComponentProps<LoaderComponentProps>) => ReactNode;
  props?: Omit<CommonLoaderComponentProps<LoaderComponentProps>, 'open'>;
};

export type GlobalLoaderDispatchContextParams<
  LoaderComponentProps extends Record<string, unknown> = Record<string, unknown>,
> = {
  closeLoader: () => void;
  openLoader: (targetLoader?: GlobalLoaderStateParams<LoaderComponentProps>) => void;
};

export const GlobalLoaderContext = createContext<GlobalLoaderDispatchContextParams>({
  openLoader: () => {},
  closeLoader: () => {},
});
